import React from 'react';
import styled from 'styled-components';
import EventSearchForm from '@features/eventList/components/EventSearchForm';

const EventSearchSidePanel = () => (
  <Container>
    <StyledEventSearchForm
      showReset
      showSubmitButton
    />
  </Container>
);
export default EventSearchSidePanel;

const Container = styled.div`
    display: flex;
    padding-top: 50px;
    position: relative;
    ::after {
      content: "";
      position: absolute;
      right: 0;
      top: 50px;
      width: 2px;
      height: 100%;
      background: var(--color-grey1);
    }
`;

const StyledEventSearchForm = styled(EventSearchForm)`
  width: 100%;
  padding-right: 40px;
`;
